import React from 'react';
import { Form } from 'react-bootstrap';

const DividerForm = ({ formValues, setFormValues }) => (
   <div></div>
);

export default DividerForm;
